import React from 'react';
import { scrollToSection } from "../../common/scrollFunctions";

function closeSideMenu(idSection) {
  scrollToSection(idSection);
  document.querySelector(".side_menu4_overlay").classList.toggle("show");
  document.querySelector(".side_menu4_overlay2").classList.toggle("show");
  document.querySelector(".side_menu_style4").classList.toggle("show");
}

function Menu() {
  return (
    <>
      <div className="side_menu4_overlay"></div>
      <div className="side_menu4_overlay2"></div>
      <div className="side_menu_style4">
        <div className="content">
          <div className="main_links">
            <ul>
              <li>
                <a href="#" className="main_link fsz-28 ltspc-3">
                  Início
                </a>
              </li>
              <li>
                <a onClick={() => closeSideMenu("id_about")} className="main_link fsz-28 ltspc-3">
                  Sobre
                </a>
              </li>
              <li>
                <a onClick={() => closeSideMenu("id_residence")} className="main_link fsz-28 ltspc-3">
                  Residence
                </a>
              </li>
              <li>
                <a onClick={() => closeSideMenu("id_health")} className="main_link fsz-28 ltspc-3">
                  Health
                </a>
              </li>
              <li>
                <a onClick={() => closeSideMenu("id_socialClub")} className="main_link fsz-28 ltspc-3">
                  Social Club
                </a>
              </li>
            </ul>
          </div>
        </div>
        <span className="clss">
          <i className="la la-times"></i>
        </span>
      </div>
    </>
  );
}

export default Menu;
